import type { FC, ReactNode } from "react";
import { NavLink } from "react-router";
import { tv } from "tailwind-variants";

interface TabsProps {
  children: ReactNode;
}

/** @deprecated Legacy component used only for project details pages. */
export const Tabs: FC<TabsProps> = ({ children }) => {
  return (
    <nav
      role="tablist"
      className="flex min-h-[50px] shrink-0 gap-3 self-stretch"
    >
      {children}
    </nav>
  );
};

const tabStyle = tv({
  base: `
    flex
    items-center
    border-b-2
    border-transparent
    px-1
    text-sm
    font-semibold
    whitespace-nowrap
    text-gray-700
    hover:border-gray-500
    hover:text-foreground
  `,
  variants: {
    isActive: {
      true: "border-indigo-500 text-indigo-600 hover:border-indigo-500 hover:text-indigo-600",
      false: "",
    },
  },
});

interface TabProps {
  to: string;
  children: ReactNode;
}

/** @deprecated Legacy component used only for project details pages. */
export const Tab: FC<TabProps> = ({ to, children }) => {
  return (
    <NavLink
      role="tab"
      to={to}
      className={({ isActive }) => tabStyle({ isActive })}
    >
      {children}
    </NavLink>
  );
};
